module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-2",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("TWO")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-d"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("‘D")]), _vm._v("rew Williams?’ The words almost choked her as they catapulted out of her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Am I seeing things?")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘The one and only,’ Helena replied. ‘You a fan?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("His biggest.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Um…’ She gulped, running her hand down her long blonde ponytail. ‘He’s ah, very gifted.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("In more ways than one.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Chrissie stole another glance in his direction. His tanned face appeared to glow under the sun’s rays, his eyes squinting, but he didn’t seem bothered. He strummed his guitar, then put it aside and jotted something down on a piece of paper. Writing a song?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘He grew up here in town, did you know that?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I knew he came from somewhere down this way, but wasn’t sure where.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yep, Tarrin’s Bay, born and bred.’ Helena swivelled the rod hanging from the Venetian blinds, reducing the sunlight to thin horizontal slits, signalling the end of Chrissie’s spying opportunity. ‘He’s asked for a session this morning, can you do that?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Now?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No, after your morning group class. 11am’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So, Damon will take over my other class?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yes. Consider Mr Williams your top priority from now on. Well, until he leaves the country on the first of March. I told him we could arrange afternoon sessions in addition to or in place of the morning class if he prefers, but he’ll see how he goes.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Chrissie nodded with a little too much enthusiasm, or perhaps nerves, and wondered if this was some kind of dream and she hadn’t even left the house yet. Maybe she was still tucked up in bed and she’d wake any minute and laugh at the fantasy she’d created.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Chrissie looked at the forms that Helena placed in her trembling hands. A lot of legal mumbo jumbo, but the gist of it was that she would not tell anyone that Drew Williams was staying at Serendipity, or that she had anything to do with him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("This was no dream. Her favourite celebrity was right outside and she’d be meeting him in less than two hours. She wanted to call her friend Melinda in Sydney and brag, but couldn’t. She would be the envy of every woman her age, and she couldn’t tell a single soul.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Thoughts bounced through her mind as Helena ducked out to make a call, leaving her alone to peruse the document and add her signature, which would probably look nothing like her real signature on account of the shaky hands. She read and re-read the document, her mind not really taking in the information, but she knew what it meant. She took a deep breath and put the tip of the pen to the paper, and scrawled "), _c('i', [_vm._v("C Burns")]), _vm._v(", complete with the little flourish at the end of the ‘s’.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("There. Done. I can keep a secret.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yes, of course, see you then. Bye.’ Helena ended her call and placed the phone on the desk, raising her eyebrows to ask if Chrissie was done.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Signed, sealed, delivered,’ Chrissie said, handing over the forms.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Fantastic. Thanks, Chrissie. I’m so glad you’ve joined us here at the retreat. Perfect timing, huh?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("That was yet to be determined. Such an important role so soon after starting a new job, in "), _c('i', [_vm._v("this ")]), _vm._v("town of all towns. She had no idea if she could handle it. But, somehow, she had to.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Now, you had a look through the V.I.P quarters only recently during your staff orientation, so you should be familiar with where everything is?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Chrissie nodded. ‘I hadn’t expected anyone to be staying there so soon.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Me neither. Usually we have a fair bit of notice, but this was a spur of the moment arrangement, apparently. Luckily Ms Kidman didn’t happen to be here at this time.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Nicole Kidman stays here?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Helena smiled, then unlocked a drawer under her desk. ‘This is a bit different to teaching in the hall above the dry-cleaners, I bet?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Hell yeah.")]), _vm._v(" Chrissie had spent a good five years running classes there in Glebe, both before and after Kai was born, and had only been at a slightly more upmarket fitness centre for just over a year before the opportunity at Serendipity came along. The fitness centre’s own V.I.P program had given her experience in one-on-one sessions and program design, but the V.I.P’s were mostly well-paid execs and spouses of the well-off rather than... famous people.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m really happy to be here.’ Chrissie smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Here you go.’ Helena handed her a key card suspended from a lanyard. ‘The key to the V.I.P quarters — the general rooms that is — obviously the sleeping quarters have a separate key.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sleeping quarters. Bedroom. Drew Williams... naughty thoughts crept into her mind and, her cheeks becoming hot, she willed them to disappear. She had to remain completely and utterly professional at all times. But you wouldn’t be a woman if you hadn’t at least imagined "), _c('i', [_vm._v("Mr Williams")]), _vm._v(" in a more personal nature at some stage in your life.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Then another thought crept into her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("How will I teach him without... touching him?")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Stop it, Chrissie!")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She took hold of the key card, its cold, hard plastic cooling her heated fingertips. This was the key to the most exclusive part of Serendipity and, symbolically, the key to a new world which, although temporary, would no doubt be challenging, exciting, scary, amazing, and unforgettable — all at the same time.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2932ff9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-002.vue
// module id = 78
// module chunks = 0